import { useQuery } from "@tanstack/react-query"
import { billingPortalQuery } from "../lib/billingPortalQuery"

export function useGetBillingPortalUrl() {
  return useQuery(billingPortalQuery())
}
